import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../../pages/Contact/Contact.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Polityka prywatności - Mikołaj Melnyk</title>
        <meta
          name="description"
          content="Polityka prywatności mojego portfolio"
        />
      </Helmet>

      <div className="legal-container">
        <h1 className="title_h1">Polityka prywatności</h1>

        <p style={{ color: '#555', fontSize: '0.95rem', marginBottom: '32px' }}>
          Ostatnia aktualizacja: 28 lutego 2026
        </p>

        <section className="legal-section">
          <h2>1. Administrator danych osobowych</h2>
          <p>Administratorem Państwa danych osobowych jest Mikołaj Melnyk.</p>
          <p>Kontakt: mikolajmelnyk16@gmail.com</p>
        </section>

        <section className="legal-section">
          <h2>2. Zakres zbieranych danych</h2>
          <p>
            Zbierane są wyłącznie dane, które Państwo dobrowolnie przekazują w
            formularzu kontaktowym:
          </p>
          <ul>
            <li>Imię i nazwisko</li>
            <li>Adres e-mail</li>
            <li>Treść wiadomości</li>
          </ul>
          <p>
            Dodatkowo, dane do celów analityki (np. statystyki odwiedzin strony)
            są zbierane wyłącznie po Państwa wyraźnej zgodzie lub odmowie zgody.
            Bez zgody, żadne informacje analityczne nie są przetwarzane.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Cel przetwarzania danych</h2>
          <p>
            Dane osobowe są przetwarzane wyłącznie w celu udzielenia odpowiedzi
            na Państwa wiadomość oraz, jeśli to konieczne, kontynuowania
            komunikacji.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Podstawa prawna przetwarzania</h2>
          <p>
            Podstawą przetwarzania danych jest dobrowolna zgoda użytkownika,
            zgodnie z art. 6 ust. 1 lit. a RODO.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Okres przechowywania danych</h2>
          <p>
            Dane są przechowywane wyłącznie przez czas niezbędny do udzielenia
            odpowiedzi na wiadomość, zazwyczaj kilka tygodni lub miesięcy, lecz
            nie dłużej niż 24 miesięcy.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Udostępnianie danych</h2>
          <p>
            Dane osobowe nie są udostępniane żadnym podmiotom trzecim ani
            przekazywane poza Europejski Obszar Gospodarczy.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Prawa osób, których dane dotyczą</h2>
          <p>Państwu przysługują następujące prawa:</p>
          <ul>
            <li>prawo dostępu do swoich danych</li>
            <li>prawo do sprostowania danych</li>
            <li>prawo do usunięcia danych</li>
            <li>prawo do cofnięcia zgody w dowolnym momencie</li>
          </ul>
          <p>
            W celu skorzystania z powyższych praw proszę o kontakt na adres
            e-mail: mikolajmelnyk16@gmail.com. Dane zostaną niezwłocznie
            poprawione lub usunięte.
          </p>
        </section>

        <p style={{ marginTop: '40px', textAlign: 'center', color: '#777' }}>
          Państwa prywatność jest dla mnie priorytetem. Wszystkie działania
          związane z przetwarzaniem danych odbywają się zgodnie z obowiązującym
          prawem.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
